/* ============================================================
   Sticky Search Bar — mobile predictive search
   Loaded by sections/sticky-search-ds.liquid
   Uses Shopify predictive-search API: /search/suggest.json
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.stickySearchReady) return;
    root.dataset.stickySearchReady = '1';

    var input          = root.querySelector('[data-sticky-search-input]');
    var placeholderEl  = root.querySelector('[data-sticky-search-placeholder]');
    var rotatorWord    = root.querySelector('[data-sticky-search-rotator-word]');
    var clearBtn       = root.querySelector('[data-sticky-search-clear]');
    var dropdown       = root.querySelector('[data-sticky-search-dropdown]');
    var suggestionsBox = root.querySelector('[data-sticky-search-suggestions]');
    var resultsBox     = root.querySelector('[data-sticky-search-results]');
    var resultsList    = root.querySelector('[data-sticky-search-results-list]');
    var resultsTitle   = root.querySelector('[data-sticky-search-results-title]');
    var seeAll         = root.querySelector('[data-sticky-search-see-all]');
    var loadingEl      = root.querySelector('[data-sticky-search-loading]');
    var emptyEl        = root.querySelector('[data-sticky-search-empty]');

    if (!input || !dropdown) return;

    var maxResults   = parseInt(root.dataset.maxResults, 10) || 6;
    var interval     = parseInt(root.dataset.rotateInterval, 10) || 2200;
    var predUrl      = root.dataset.searchUrl   || '/search/suggest.json';
    var searchPgUrl  = root.dataset.searchPageUrl || '/search';

    var rotateWords = [];
    if (rotatorWord) {
      var raw = rotatorWord.textContent.trim();
      if (raw) rotateWords.push(raw);
    }
    var initialWords = (root.dataset.rotateWords || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (initialWords.length) rotateWords = initialWords;
    if (rotateWords.length === 0) rotateWords = ['Air Fryer', 'Cookware', 'Tawa', 'Blender'];

    /* ---------- Rotating placeholder ---------- */
    var rotateIdx = 0;
    var rotateTimer = null;
    function startRotator() {
      if (!rotatorWord || rotateWords.length < 2) return;
      stopRotator();
      rotateTimer = setInterval(function () {
        rotatorWord.classList.add('is-leave');
        setTimeout(function () {
          rotateIdx = (rotateIdx + 1) % rotateWords.length;
          rotatorWord.textContent = rotateWords[rotateIdx];
          rotatorWord.classList.remove('is-leave');
          rotatorWord.classList.add('is-enter');
          requestAnimationFrame(function () {
            rotatorWord.classList.remove('is-enter');
          });
        }, 340);
      }, interval);
    }
    function stopRotator() {
      if (rotateTimer) clearInterval(rotateTimer);
      rotateTimer = null;
    }
    startRotator();

    /* ---------- Scroll shadow ---------- */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = root.getBoundingClientRect();
        if (rect.top <= 0) root.classList.add('is-scrolled');
        else root.classList.remove('is-scrolled');
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ---------- Helpers ---------- */
    function escapeHTML(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
      });
    }
    function highlight(text, q) {
      if (!q) return escapeHTML(text);
      var safe = escapeHTML(text);
      var needle = escapeHTML(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      try {
        return safe.replace(new RegExp('(' + needle + ')', 'ig'), '<mark>$1</mark>');
      } catch (e) { return safe; }
    }
    function formatMoney(value) {
      if (value == null || value === '') return '';
      var n = parseFloat(String(value).replace(/[^\d.-]/g, ''));
      if (isNaN(n)) return '';
      return '₹' + Math.round(n).toLocaleString('en-IN');
    }
    function productHTML(p, q) {
      var imgSrc = '';
      if (p.image) imgSrc = p.image;
      else if (p.featured_image && p.featured_image.url) imgSrc = p.featured_image.url;
      else if (p.featured_image) imgSrc = p.featured_image;

      var meta = p.product_type || p.vendor || '';
      var priceVal = p.price != null ? p.price : (p.price_min != null ? p.price_min : null);
      var price = priceVal != null ? formatMoney(priceVal) : '';
      var compareAt = null;
      var candidates = [p.compare_at_price, p.compare_at_price_min, p.compare_at_price_max];
      for (var i = 0; i < candidates.length; i++) {
        var c = candidates[i];
        if (c != null && c !== '' && parseFloat(c) > 0) { compareAt = c; break; }
      }
      var compareStr = '';
      if (compareAt && priceVal != null && parseFloat(compareAt) > parseFloat(priceVal)) {
        compareStr = '<span class="sticky-search-ds__product-strike">' + formatMoney(compareAt) + '</span>';
      }
      var pctOff = '';
      if (compareAt && priceVal != null && parseFloat(compareAt) > parseFloat(priceVal)) {
        var pct = Math.round((1 - parseFloat(priceVal) / parseFloat(compareAt)) * 100);
        if (pct > 0) pctOff = '<span class="sticky-search-ds__product-pct">-' + pct + '%</span>';
      }

      return ''
        + '<a class="sticky-search-ds__product" href="' + escapeHTML(p.url || '#') + '">'
        +   '<div class="sticky-search-ds__product-img-wrap">'
        +     (imgSrc ? '<img class="sticky-search-ds__product-img" src="' + escapeHTML(imgSrc) + '" alt="' + escapeHTML(p.title || '') + '" loading="lazy" />' : '<div class="sticky-search-ds__product-img"></div>')
        +     pctOff
        +   '</div>'
        +   '<div class="sticky-search-ds__product-info">'
        +     '<div class="sticky-search-ds__product-title">' + highlight(p.title || '', q) + '</div>'
        +     (meta ? '<div class="sticky-search-ds__product-meta">' + escapeHTML(meta) + '</div>' : '')
        +     '<div class="sticky-search-ds__product-price-row">'
        +       '<span class="sticky-search-ds__product-price">' + (price || '') + '</span>'
        +       (compareStr ? ' ' + compareStr : '')
        +     '</div>'
        +   '</div>'
        + '</a>';
    }

    /* ---------- Dropdown open/close ---------- */
    function openDropdown() { dropdown.hidden = false; }
    function closeDropdown() { dropdown.hidden = true; }
    function showSuggestions() {
      if (suggestionsBox) suggestionsBox.hidden = false;
      if (resultsBox) resultsBox.hidden = true;
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
    }
    function showResults() {
      if (suggestionsBox) suggestionsBox.hidden = true;
      if (resultsBox) resultsBox.hidden = false;
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
    }
    function showLoading() {
      if (suggestionsBox) suggestionsBox.hidden = true;
      if (resultsBox) resultsBox.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (loadingEl) loadingEl.hidden = false;
    }
    function showEmpty(q) {
      if (suggestionsBox) suggestionsBox.hidden = true;
      if (resultsBox) resultsBox.hidden = true;
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.innerHTML = 'No products found for &ldquo;<strong>' + escapeHTML(q) + '</strong>&rdquo;';
      }
    }

    /* ---------- Predictive search fetch ---------- */
    var currentXhr = null;
    var debounceTimer = null;
    function fetchResults(q) {
      if (currentXhr && currentXhr.abort) { try { currentXhr.abort(); } catch (e) {} }
      var url = predUrl
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=' + maxResults
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,vendor,variants.title';

      showLoading();
      var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      currentXhr = controller;
      var fetchOpts = controller ? { signal: controller.signal, credentials: 'same-origin' } : { credentials: 'same-origin' };

      fetch(url, fetchOpts)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { showEmpty(q); return; }
          resultsList.innerHTML = products.map(function (p) { return productHTML(p, q); }).join('');
          if (resultsTitle) resultsTitle.textContent = 'Products (' + products.length + ')';
          if (seeAll) {
            seeAll.style.display = '';
            seeAll.textContent = 'See all results for "' + q + '" →';
            seeAll.href = searchPgUrl + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
          }
          showResults();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          showEmpty(q);
        });
    }
    function debouncedFetch(q) {
      showLoading();
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { fetchResults(q); }, 80);
    }

    /* ---------- Events ---------- */
    input.addEventListener('focus', function () {
      if (placeholderEl) placeholderEl.classList.add('is-hidden');
      stopRotator();
      openDropdown();
      var v = input.value.trim();
      if (v) debouncedFetch(v); else showSuggestions();
    });

    input.addEventListener('blur', function () {
      // Note: we DON'T close the dropdown on blur. That's intentional so on mobile,
      // dismissing the keyboard (via scroll-to-dismiss below) keeps the dropdown open
      // so user can see all the chips / best sellers / sale banner. Dropdown only
      // closes via the click-outside handler at the bottom of this file.
      if (!input.value) {
        if (placeholderEl) placeholderEl.classList.remove('is-hidden');
        startRotator();
      }
    });

    /* ---------- Mobile keyboard handling ----------
       When user starts scrolling the dropdown while input is focused,
       blur the input → dismisses the soft keyboard → the full dropdown
       becomes visible. Tapping input again brings keyboard back. */
    var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (isTouchDevice && dropdown) {
      var touchStartY = 0;
      dropdown.addEventListener('touchstart', function (e) {
        touchStartY = e.touches && e.touches[0] ? e.touches[0].clientY : 0;
      }, { passive: true });
      dropdown.addEventListener('touchmove', function (e) {
        if (document.activeElement !== input) return;
        var currentY = e.touches && e.touches[0] ? e.touches[0].clientY : 0;
        // Only blur if user moved at least 6px (avoids dismissing on stray touches)
        if (Math.abs(currentY - touchStartY) > 6) {
          input.blur();
        }
      }, { passive: true });
    }

    input.addEventListener('input', function () {
      var v = input.value;
      if (v.trim()) {
        if (clearBtn) clearBtn.classList.add('is-visible');
        if (placeholderEl) placeholderEl.classList.add('is-hidden');
        debouncedFetch(v.trim());
      } else {
        if (clearBtn) clearBtn.classList.remove('is-visible');
        showSuggestions();
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var q = input.value.trim();
        if (q) window.location.href = searchPgUrl + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
      } else if (e.key === 'Escape') {
        input.blur();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.classList.remove('is-visible');
        showSuggestions();
        input.focus();
      });
    }

    /* ---------- Click outside to close ---------- */
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeDropdown();
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    document.querySelectorAll('[data-sticky-search]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when theme editor loads/reloads the section
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-sticky-search]');
    if (el) init(el);
  });
})();
